import React from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { Chat, ChatBody, ChatFooter, ChatForm, ChatOriginalText } from '@/components/custom/chat/chat';
import { ChatMessageWrapper, ChatMessage, ChatMessageInside, ChatMessageHeader, ChatMessageTitle, ChatMessageBody, ChatMessageText, ChatMessageActions } from '@/components/custom/chat/chat-message';
import { AvatarWrapper } from '@/components/ui/avatar';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { FiSend, FiMoreVertical } from 'react-icons/fi';

const MESSAGES = [
  { id: '3', author: 'Você', text: 'Vou explicar agora! O segredo é dividir as duas partes da equação.', time: '14:32' },
  { id: '2', author: 'Ana Silva', badge: 'Professora', text: 'Alguém entendeu a questão 5 do exercício de algebra?', time: '14:30' },
  { id: '1', author: 'Bruno Santos', text: 'Bom dia turma! Vamos comecar a aula de hoje.', time: '14:28' }
];

export function ChatSection() {
  return (
    <ShowcaseSection
      id="chat"
      title="Chat"
      description="Componentes de chat para mensagens em tempo real e discussoes"
    >
      <ShowcaseItem
        label="Chat completo"
        description="Container Chat + ChatBody (lista de mensagens) + ChatFooter (form de envio)"
      >
        <Chat>
          <ChatBody>
            {MESSAGES.map(msg => (
              <ChatMessageWrapper key={msg.id}>
                <ChatMessage>
                  <AvatarWrapper
                    name={msg.author}
                    size="sm"
                  />
                  <ChatMessageInside>
                    <ChatMessageHeader>
                      <ChatMessageTitle>{msg.author}</ChatMessageTitle>
                      {msg.badge && (
                        <Badge
                          variant="primary-light"
                          size="xs"
                        >
                          {msg.badge}
                        </Badge>
                      )}
                      <span className="text-[10px] text-neutral">{msg.time}</span>
                    </ChatMessageHeader>
                    <ChatMessageBody>
                      <ChatMessageText>{msg.text}</ChatMessageText>
                    </ChatMessageBody>
                  </ChatMessageInside>
                  <ChatMessageActions>
                    <Button
                      variant="ghost"
                      size="xs"
                    >
                      <FiMoreVertical size={14} />
                    </Button>
                  </ChatMessageActions>
                </ChatMessage>
              </ChatMessageWrapper>
            ))}
          </ChatBody>
          <ChatFooter>
            <ChatForm>
              <Input
                placeholder="Digite sua mensagem..."
                className="flex-1"
              />
              <Button size="sm">
                <FiSend size={14} /> Enviar
              </Button>
            </ChatForm>
          </ChatFooter>
        </Chat>
      </ShowcaseItem>

      <ShowcaseItem
        label="ChatFooter — variante reply"
        description="Footer com texto original em destaque para resposta"
      >
        <Chat>
          <ChatBody>
            <ChatMessageWrapper>
              <ChatMessage>
                <AvatarWrapper
                  name="Ana Silva"
                  size="sm"
                />
                <ChatMessageInside>
                  <ChatMessageHeader>
                    <ChatMessageTitle>Ana Silva</ChatMessageTitle>
                  </ChatMessageHeader>
                  <ChatMessageBody>
                    <ChatMessageText>Voces poderiam revisar a aula 3 antes da prova?</ChatMessageText>
                  </ChatMessageBody>
                </ChatMessageInside>
              </ChatMessage>
            </ChatMessageWrapper>
          </ChatBody>
          <ChatFooter variant="reply">
            <ChatOriginalText>Respondendo a Ana Silva</ChatOriginalText>
            <ChatForm>
              <Input
                placeholder="Sua resposta..."
                className="flex-1"
              />
              <Button size="sm">Responder</Button>
            </ChatForm>
          </ChatFooter>
        </Chat>
      </ShowcaseItem>

      <ShowcaseItem
        label="ChatMessage — variante reply"
        description="Mensagem com fundo destacado (resposta a outra mensagem)"
      >
        <Chat>
          <ChatBody>
            <ChatMessageWrapper>
              <ChatMessage>
                <AvatarWrapper
                  name="Bruno"
                  size="sm"
                />
                <ChatMessageInside>
                  <ChatMessageHeader>
                    <ChatMessageTitle>Bruno Santos</ChatMessageTitle>
                  </ChatMessageHeader>
                  <ChatMessageBody>
                    <ChatMessageText>Mensagem original</ChatMessageText>
                  </ChatMessageBody>
                </ChatMessageInside>
              </ChatMessage>
            </ChatMessageWrapper>
            <ChatMessageWrapper variant="reply">
              <ChatMessage>
                <AvatarWrapper
                  name="Carla"
                  size="sm"
                />
                <ChatMessageInside>
                  <ChatMessageHeader>
                    <ChatMessageTitle>Carla Oliveira</ChatMessageTitle>
                    <Badge
                      variant="primary-light"
                      size="xs"
                    >
                      Resposta
                    </Badge>
                  </ChatMessageHeader>
                  <ChatMessageBody>
                    <ChatMessageText>Esta e uma resposta a mensagem do Bruno (note o fundo bright e o separador).</ChatMessageText>
                  </ChatMessageBody>
                </ChatMessageInside>
              </ChatMessage>
            </ChatMessageWrapper>
          </ChatBody>
        </Chat>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
